export enum LongFloatThreadType {
  WARP = 'WARP',
  PILE = 'PILE',
  WEFT = 'WEFT'
}
